import { assign, createMachine, StatesConfig } from "xstate";
import { setZipCode, setEstimation, setCurrentProductIdStore, setStartDates, setResidenceType, setProductType, getStore, updateStorage, } from "./actions";
import { estimationScreenState } from "./screenStates/PurchaseModule/estimationScreenState";
import { priceScreenState } from "./screenStates/PurchaseModule/priceScreenState";
const { estimation, zipCode, residenceType } = getStore();
const initState = {
    selectedProductId: null,
    estimation: estimation ? estimation : 0,
    campaign: "",
    facilityInformation: {
        residenceType,
        zipcode: zipCode,
    },
    forceShowEstimation: false,
    showVariable: true,
    showFixed: true,
};
const url = new URL(window.location.href);
if (url.searchParams.get("forbrukning") && url.searchParams.get("postnr")) {
    initState.estimation = +url.searchParams.get("forbrukning");
    initState.facilityInformation.zipcode = url.searchParams.get("postnr");
    initState.facilityInformation.residenceType = initState.estimation < 7500 ? "apartment" : "house";
    initState.forceShowEstimation = true;
    updateStorage({
        zipCode: initState.facilityInformation.zipcode,
        estimation: initState.estimation,
        residenceType: "house",
    });
}
export const purchaseModuleStore = createMachine({
    id: "machineModule",
    predictableActionArguments: false,
    initial: "estimation",
    context: initState,
    on: {
        SET_CAMPAIGN: {
            actions: assign({
                campaign: (context, event) => event.campaign,
            }),
        },
        SET_HIDE_VARIABLE: {
            actions: assign({
                showVariable: false,
                showFixed: true,
            }),
        },
        SET_HIDE_FIXED: {
            actions: assign({
                showFixed: false,
                showVariable: true,
            }),
        },
    },
    states: {
        estimation: estimationScreenState,
        price: priceScreenState,
    },
}, {
    actions: {
        setZipCode,
        setEstimation,
        setCurrentProductIdStore,
        setResidenceType,
        setProductType,
        setStartDates,
    },
});
